import F84Game from "../../Game";

export default class ImageOverride {
	/*
	 * This tricks phaser into thinking that textures are a different size than they actually are.
	 * Allowing us to server different res textures with the exact same layout as our base resolution
	 */
	static override(resolution: number): void {
		// const pipeline = (F84Game.Instance.renderer as Phaser.Renderer.WebGL.WebGLRenderer).getPipeline('TextureTintPipeline');
		// const prevBatchFunc = Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline.prototype.batchSprite.bind(pipeline);
		// Phaser.Renderer.WebGL.Pipelines.TextureTintPipeline.prototype.batchSprite = function(sprite, camera, parentTransformMatrix):void
		// {
		//     sprite.scale *= r;
		//     prevBatchFunc(sprite, camera, parentTransformMatrix);
		//     sprite.scale /= r;
		// };

		const r = resolution;

		// Phaser.Loader.File.prototype.load = function (): void {
		//     if (this instanceof Phaser.Loader.FileTypes.ImageFile) {
		//         if (this.url.indexOf("override") == -1) {
		//             //hack prevents avatars from trying to load lq
		//             if (r != 1) this.url = this.url.replace(".png", "_lq.png");
		//         } else {
		//             this.url = this.url.replace("override", "");
		//         }
		//     }
		//     if (this instanceof Phaser.Loader.FileTypes.JSONFile) {
		//         //hack for skipping regular lottie spritesheets
		//         if (this.url.indexOf("override") != -1) {
		//             this.url = this.url.replace("override", "json");
		//         } else if (this.url.indexOf("locale") == -1) {
		//             //skip locale such as strings.json
		//             if (r != 1) this.url = this.url.replace(".json", "_lq.json");
		//         }
		//     }

		//     if (this.state === Phaser.Loader.FILE_POPULATED) {
		//         //  Can happen for example in a JSONFile if they've provided a JSON object instead of a URL
		//         this.loader.nextFile(this, true);
		//     } else {
		//         this.src = Phaser.Loader.GetURL(this, this.loader.baseURL);

		//         if (this.src.indexOf("data:") === 0) {
		//             console.warn("Local data URIs are not supported: " + this.key);
		//         } else {
		//             //  The creation of this XHRLoader starts the load process going.
		//             //  It will automatically call the following, based on the load outcome:
		//             //
		//             // xhr.onload = this.onLoad
		//             // xhr.onerror = this.onError
		//             // xhr.onprogress = this.onProgress

		//             this.xhrLoader = Phaser.Loader.XHRLoader(this, this.loader.xhr);
		//         }
		//     }
		// };

		// Phaser.Loader.FileTypes.AtlasJSONFile.prototype.addToCache = function (): void {
		//     if (this.isReadyToProcess())
		//     {
		//         const image = this.files[0];
		//         const json = this.files[1];
		//         const normalMap = (this.files[2]) ? this.files[2].data : null;

		//         console.log(json);

		//         this.loader.textureManager.addAtlas(image.key, image.data, json.data, normalMap);

		//         json.addToCache();

		//         this.complete = true;

		//         //hack, not the best
		//         const data = F84Game.Instance.cache.json.get(json.key);
		//         if(data.meta)
		//         {
		//             console.log("Adjust meta size");
		//             data.meta.size.w/=r;
		//             data.meta.size.h/=r;
		//         }
		//     }
		// };

		Phaser.Loader.FileTypes.SpriteSheetFile.prototype.addToCache = function (): void {
			const config = <any>this.config; //frame config
			config.frameHeight *= r;
			config.frameWidth *= r;
			const texture = this.cache.addSpriteSheet(this.key, this.data, this.config);
			this.pendingDestroy(texture);
		};

		// removed because we now call overrideTexture in LoaderScene after loading each image
		// F84Game.Instance.textures.on(Phaser.Textures.Events.ADD, (key: string, texture: Phaser.Textures.Texture): void => {
		//     this.overrideTexture(texture);
		// });

		const snapshot = Phaser.GameObjects.Video.prototype.snapshot;
		Phaser.GameObjects.Video.prototype.snapshot = function (
			this: Phaser.GameObjects.Video,
			width?: number,
			height?: number
		): Phaser.Textures.CanvasTexture {
			return snapshot.call(this, width / r, height / r);
		};
	}

	static overrideTexture(texture: Phaser.Textures.Texture): void {
		const r = F84Game.Instance.quality.resolution;

		Object.entries(texture.frames).forEach((prop) => {
			const frame: Phaser.Textures.Frame = prop[1];
			frame.centerX /= r;
			frame.centerY /= r;
			frame.x /= r;
			frame.y /= r;
			frame.cutX /= r;
			frame.cutY /= r;
			frame.cutHeight /= r;
			frame.cutWidth /= r;
			frame.halfHeight /= r;
			frame.halfWidth /= r;
			frame.height /= r;
			frame.width /= r;
			const data = (<any>frame).data;
			data.cut.b /= r;
			data.cut.h /= r;
			data.cut.r /= r;
			data.cut.w /= r;
			data.cut.x /= r;
			data.cut.y /= r;
			data.drawImage.x /= r;
			data.drawImage.y /= r;
			data.drawImage.width /= r;
			data.drawImage.height /= r;
			data.radius /= r;
			data.sourceSize.w /= r;
			data.sourceSize.h /= r;
			data.spriteSourceSize.x /= r;
			data.spriteSourceSize.y /= r;
			data.spriteSourceSize.w /= r;
			data.spriteSourceSize.h /= r;
			const customData = (<any>frame).customData;
			if (customData.frame) {
				customData.frame.x /= r;
				customData.frame.y /= r;
				customData.sourceSize.w /= r;
				customData.sourceSize.h /= r;
				customData.spriteSourceSize.x /= r;
				customData.spriteSourceSize.y /= r;
				customData.spriteSourceSize.h /= r;
				customData.spriteSourceSize.w /= r;
			}
		});
		texture.source.forEach((source) => {
			source.height /= r;
			source.width /= r;
		});
	}
}
